<template>
  <div class="mainPage">
    <div class="filters">
      <input class="input-filter" @input="filter" placeholder="Search for specific item..." type="text">
      <div>Type</div>
      <button class="sort" @click="sortList">
        Sort
        <p v-if="sort > 0">&DownArrow;</p>
        <p v-if="sort < 0">&UpArrow;</p>
      </button>
    </div>
    <div class="grid">
      <div v-for="(item) in productsCopy" :key="item.id" @click="show(item)">
        <ProductCard :imgPath="item.path" :name="item.name" :price="item.price" :type="item.type"></ProductCard>
      </div>
    </div>
  </div>
  <PurchasePage @closeModal="hide()" :class="open" :imgPath="selected.path" :name="selected.name" :price="selected.price"
    :type="selected.type"></PurchasePage>
</template>

<script>
import ProductCard from '../components/ProductCard.vue'
import PurchasePage from '../components/PurchasePage'
    
export default {
  name: 'MainPage',
  components: {
    ProductCard,
    PurchasePage,
  },
  props: {
  },
  data() {
    return {
      products: [
        { id: 0, name: "IdeaPad 3i Gen 7", path: "/laptop1.png", price: 127, type: 0 },
        { id: 1, name: "Bose Headphones", path: "/headphones.png", price: 57, type: 3 },
        { id: 2, name: "HP Monitor", path: "/monitor.png", price: 20, type: 2 },
        { id: 3, name: "Dell Vostro 3671", path: "/desktop.png", price: 145, type: 1 },
        { id: 4, name: "IdeaPad 3i Gen 7", path: "/laptop1.png", price: 73, type: 0 },
        { id: 5, name: "Bose Headphones", path: "/headphones.png", price: 250, type: 3 },
        { id: 6, name: "HP Monitor", path: "/monitor.png", price: 45, type: 2 },
        { id: 7, name: "Dell Vostro 3671", path: "/desktop.png", price: 341, type: 1 },
        { id: 8, name: "IdeaPad 3i Gen 7", path: "/laptop1.png", price: 98, type: 0 },
        { id: 9, name: "Bose Headphones", path: "/headphones.png", price: 13, type: 3 },
        { id: 10, name: "HP Monitor", path: "/monitor.png", price: 230, type: 2 },
        { id: 11, name: "Logitech Mouse Mx", path: "/mouse.png", price: 5, type: 3 },
        { id: 12, name: "Logitech Mouse Mx", path: "/mouse.png", price: 10, type: 3 },
        { id: 13, name: "Logitech Mouse Mx", path: "/mouse.png", price: 32, type: 3 },
        { id: 14, name: "Logitech Mouse Mx", path: "/mouse.png", price: 89, type: 3 },
        { id: 15, name: "IdeaPad 3i Gen 7", path: "/laptop1.png", price: 98, type: 0 },
        { id: 16, name: "IdeaPad 3i Gen 7", path: "/laptop1.png", price: 98, type: 0 },
        { id: 17, name: "Dell Vostro 3671", path: "/desktop.png", price: 150, type: 1 },
        { id: 18, name: "HP Monitor", path: "/monitor.png", price: 45, type: 2 },
        { id: 19, name: "HP Monitor", path: "/monitor.png", price: 77, type: 2 },
        { id: 20, name: "Dell Vostro 3671", path: "/desktop.png", price: 150, type: 1 },
        { id: 21, name: "Dell Vostro 3671", path: "/desktop.png", price: 150, type: 1 },
        { id: 22, name: "Dell Vostro 3671", path: "/desktop.png", price: 150, type: 1 },

      ],
      productsCopy: [],
      sort: 1,
      open: "false",
      selected: {},
    }
  },
  mounted() {
    this.products = this.products.sort((a, b) => a.price - b.price);
    this.productsCopy = JSON.parse(JSON.stringify(this.products));
  },
  methods: {
    sortList() {
      if (this.sort < 0) {
        this.productsCopy.sort((a, b) => a.price - b.price);
        this.sort *= -1;
      } else {
        this.productsCopy.sort((a, b) => b.price - a.price);
        this.sort *= -1;
      }
    },
    filter(event) {
      const value = event.data;
      if (value == null) {
        this.productsCopy = this.products;
      } else {
        var newList = []
        for (var i = 0; i < Object.keys(this.productsCopy).length; i++) {
          if (this.productsCopy[i].name.toUpperCase().includes(value.toUpperCase())) {
            var id = this.productsCopy[i].id;
            var name = this.productsCopy[i].name;
            var path = this.productsCopy[i].path;
            var price = this.productsCopy[i].price;
            var type = this.productsCopy[i].type;
            newList.push({ id, name, path, price, type });
          }
        }
        this.productsCopy = newList;
      }
    },
    show(item) {
      this.open = true;
      this.selected = item;
    },
    hide() {
      this.open = "false";
    },
  }
}
</script>

<style scoped>
.mainPage {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
}

.grid {
  margin-top: 3em;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  height: 132px;
}

.filters {
  display: flex;
  margin-top: 2em;
  margin-left: 2%;
  align-items: center;
  justify-content: flex-start;
}

.filters>* {
  margin: 0 1em;
}

.input-filter {
  background-color: white;
  border: 1px solid black;
  border-radius: 0.3em;
  height: 30px;
  width: 15%;
  font-size: medium;
}

.sort {
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: white;
  border: none;
  padding: 0px 15px;
  border-radius: 0.5em;
  font-size: 16px;
  padding: 5px 15px;
}

.sort>p {
  margin-left: 10px;
  margin-top: 0;
  margin-bottom: 0;
}

.false {
  display: none;
}

.true {
  display: block;
}
</style>
